



























































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Form from "@/components/form.vue";
import {State} from "vuex-class";
import Cta from "@/components/cta.vue";
import Loader from "@/components/loader.vue";
import Selector from "@/components/selector.vue";
import moment from "moment";
import {Listen} from "@/utilities/decorators";
import {getCookie, openCheckout} from "@/utilities/utilities";
import {startUpSelector} from "@/main";
import {QuestionBase} from "@/utilities/question-base";

@Component({
    components: {Loader, Cta, Form},
    name: 'cart'
}) export default class extends Vue {
    active = false;
    error = null;
    @Prop() checkoutCart;
    @State('cart') stateCart;
    @Prop() canEdit;
    @State('selector') selector;
    @State('reservationId') reservationId;
    items = [];
    transactionCosts = 0;
    couponQuestions = [];
    discountAmount = -1;
    
    get cart() {
        return this.stateCart;
    }

    get isActive() {
        return this.active || this.canEdit;
    }

    beforeMount() {
        this.couponQuestions = [
            new QuestionBase({
                label: this.$t('coupon'),
                key: 'coupon',
                required: true
            })
        ];

        this.$eventEmitter.subscribe('setCartActive', this.setActive.bind(this));
        this.$eventEmitter.subscribe('setTransactionCosts', this.setTransactionCosts.bind(this));
    }

    setTransactionCosts(val) {
        this.transactionCosts = val;
    }

    mounted() {
        if (this.cart) {
            this.items = this.getItems();
        }
    }

    openCheckout() {
        if(!this.selector.checkout_URL.length || window.location.href.includes('localhost')) {
            openCheckout();
        } else {
            window.open(`${this.selector.checkout_URL}?reservationId=${this.reservationId}`, "_self");
        }
    }

    async remove(item) {
        this.$eventEmitter.emit('setLoaderActive', true);

        let cart = Object.assign({}, this.cart);

        cart.CartEntries = cart.CartEntries.filter(entry => !this.isSameEvent(item, entry));

        let response = await this.$api.post('updatecart', {
            Cart: cart,
            Reservation_id: this.reservationId
        }).catch(alert);

        this.$eventEmitter.emit('setLoaderActive', false);

        if (response) {
            this.$store.dispatch('setCart', response.Cart);
        }
    }

    async submitCoupon() {
        let form:any = this.$refs.couponForm,
            values = form.submit();

        this.$eventEmitter.emit('setLoaderActive', true);

        if (values) {
            
            let response = await this.$api.post('UpdateCart', {
                Reservation_id: this.reservationId,
                Cart: this.cart,
                DiscountCode: values.coupon
            }).catch(error => {

                this.error = error.response.data;
            });
            if (response) {
                this.discountAmount = response.Cart.DiscountAmount;
                if (this.discountAmount < 0) {
                    this.error = this.$t('invalidCode');
                } else {
                    this.error = null;
                }
                this.$store.dispatch('setCart', response.Cart);
            }
        }

        this.$eventEmitter.emit('setLoaderActive', false);
    }

    async edit(item) {
        this.$eventEmitter.emit('setLoaderActive', true);

        if (item.eventId == this.$api.eventId) {
            this.$eventEmitter.emit('openPopup', Selector, Object.assign({}, item, {
                ticketTypes: this.selector.TicketTypeList,
                frequency: this.selector.Frequency,
                slotAvailability: this.$store.state.slotAvailability,
                dateAvailability: this.$store.state.dateAvailability
            }));
        } else {
            let [selectorResponse, dateAvailabilityResponse, slotAvailabilityResponse] = await startUpSelector(item.eventId, item.date || moment());

            if(selectorResponse && dateAvailabilityResponse && slotAvailabilityResponse) {
                this.$eventEmitter.emit('openPopup', Selector, Object.assign({}, item, {
                    ticketTypes: selectorResponse.TicketTypeList,
                    frequency: selectorResponse.Frequency,
                    dateAvailability: dateAvailabilityResponse.Dates,
                    slotAvailability: slotAvailabilityResponse
                }));
            }
        }

        this.$eventEmitter.emit('cartUpdated');
        this.$eventEmitter.emit('setLoaderActive', false);
    }

    @Listen('click') onClick() {
        this.setActive(false);
    }

    @Watch('cart') onCartChange() {
        this.items = this.getItems();
    }

    getItems() {
        if(!this.cart.CartEntries) return [];

        return this.cart.CartEntries.filter(entry => entry.Quantity).reduce(this.reduceCartEntries, []);
    }

    setActive(val) {
        this.active = val;
    }

    isSameEvent(arrItem, item) {
        let isSameEvent = arrItem.eventName === item.Event_name;
        return !item.From_datetime_slot && isSameEvent || item.From_datetime_slot && moment(item.From_datetime_slot).isSame(arrItem.date) && isSameEvent;
    }

    reduceCartEntries(arr: any, item) {
        let isSame = arr.find((arrItem) => this.isSameEvent(arrItem, item));

        if (!isSame) {
            arr.push({
                eventId: item.Event_id,
                date: item.From_datetime_slot ? moment(item.From_datetime_slot) : null,
                slot: item.From_datetime_slot,
                tickets: [this.getNormalizedTicket(item)],
                lineTotal: item.Price,
                eventName: item.Event_name
            })
        } else {
            isSame.tickets.push(this.getNormalizedTicket(item));
            isSame.lineTotal += item.Price;
        }

        return arr;
    }

    getNormalizedTicket(item) {
        return {
            quantity: item.Quantity,
            subTitle: item.Subtitle,
            id: item.TicketType_id,
            name: item.TicketType_name,
            price: item.Price
        };
    }
}
